import { useOktaContext } from 'mf_core/auth';
import { useLogoutContext } from 'mf_core/logout';
import { ExtraHeaders, ObjectMap, useApiQuery } from 'mf_core/query';
import { UseQueryOptions } from '@tanstack/react-query';

/** Wrapper for CMS API queries to handle logout mode operations + UserLoggedIn data mandatory */
export function useCMSApiQuery<TO = ObjectMap>(
  route: string,
  params?: ObjectMap,
  useQueryOptions?: Partial<UseQueryOptions<TO>>,
  extraHeaders?: ExtraHeaders
) {
  const oktaContext = useOktaContext();
  const isAuthenticated = Boolean(oktaContext?.authState?.isAuthenticated);
  const cmsData = useLogoutContext();
  route = isAuthenticated ? route : route.replace('/cms/v1', '/cms-noauth/v1');

  return useApiQuery<TO>(
    route,
    { ...params, UserLoggedIn: isAuthenticated },
    useQueryOptions,
    extraHeaders,
    {
      isLogoutApi: !isAuthenticated && !!cmsData?.data?.isLogoutEnabled,
    }
  );
}
